import { InMemoryCache } from '@apollo/client';

export const cache: InMemoryCache = new InMemoryCache({
  possibleTypes: {
    SetMainProduct: ['Product', 'ColoredProduct'],
    SetProductsItem: ['Product', 'ColoredProduct'],
    ProductYouMayAlsoLikeItem: ['Product', 'Set'],
    SetYouMayAlsoLikeItem: ['Product', 'Set']
  }
});
